import React from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'
import { Slider } from '@mobi/component-library/Selection&Input/Slider'

export const RangeInput: React.FC<{
  selectedValues: number[]
  minRange: number
  maxRange: number
  minChangedCallback: (value: number) => void
  maxChangedCallback?: (value: number) => void
  testId: string
  isMaxInfinite?: boolean
  isCurrency?: boolean
  isPercentage?: boolean
}> = ({
  selectedValues,
  minRange,
  maxRange,
  minChangedCallback,
  maxChangedCallback,
  testId,
  isMaxInfinite,
  isCurrency,
  isPercentage,
}) => {
  const values = Array.from({ length: maxRange - minRange + 1 }, (_, i) => minRange + i)

  const changedCallback = (newValues: number[]) => {
    if (newValues[0] !== selectedValues[0]) {
      minChangedCallback(newValues[0])
    }

    if (newValues[1] !== selectedValues[1]) {
      if (maxChangedCallback) maxChangedCallback(newValues[1])
    }
  }

  return (
    <div>
      <RangeInputComponent
        selectedValues={selectedValues}
        values={values}
        testId={testId}
        changedCallback={changedCallback}
        isMaxInfinite={isMaxInfinite}
        isCurrency={isCurrency}
        isPercentage={isPercentage}
      />
    </div>
  )
}

// ===============
// Local Component
// ===============

const RangeInputComponent: React.FC<{
  values: number[]
  selectedValues: number[]
  changedCallback: (value: number[]) => void
  testId: string
  isMaxInfinite?: boolean
  isCurrency?: boolean
  isPercentage?: boolean
}> = ({
  values,
  selectedValues,
  testId,
  changedCallback,
  isMaxInfinite,
  isCurrency,
  isPercentage,
}) => {
  const prefix = isCurrency ? '$' : null
  const suffix = isMaxInfinite ? '+' : isPercentage ? '%' : null

  return (
    <RangeInputContainerStyled>
      <Slider
        values={values}
        selectedValues={selectedValues}
        onChange={newValues => changedCallback(newValues)}
        prefix={prefix}
        suffix={suffix}
        testId={testId}
      />
    </RangeInputContainerStyled>
  )
}

const RangeInputContainerStyled = styled.div({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  padding: `${spacing.smx2} 0 ${spacing.smx1} 0`,
})
